"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCapacitor = exports.CapacitorContext = void 0;
exports.CapacitorProvider = CapacitorProvider;
const react_1 = __importStar(require("react"));
const core_1 = require("@capacitor/core");
const token_1 = require("lincd-auth/lib/utils/token");
const preferences_1 = require("@capacitor/preferences");
const app_1 = require("@capacitor/app");
const react_router_dom_1 = require("react-router-dom");
exports.CapacitorContext = (0, react_1.createContext)(null);
function useCapacitorProvider() {
    return {
        Capacitor: core_1.Capacitor,
    };
}
function CapacitorProvider({ children }) {
    const capacitor = useCapacitorProvider();
    const navigate = (0, react_router_dom_1.useNavigate)();
    /**
     * AppUrlListener, used to handle deep links
     */
    (0, react_1.useEffect)(() => {
        app_1.App.addListener('appUrlOpen', (event) => {
            // use URL constructor to parse the URL
            // example:
            // https://beerswift.com/tabs/tab2 --> /tabs/tab2
            // https://www.peacegame.earth/tabs --> /tabs
            const url = new URL(event.url);
            // extract the path from the URL
            const slug = url.pathname;
            // log the deeplink URL
            if (process.env.NODE_ENV === 'staging') {
                console.log('deeplink: ', slug);
            }
            if (slug) {
                navigate(slug);
            }
        });
    }, []);
    /**
     * set the storage token methods for Capacitor
     */
    (0, react_1.useEffect)(() => {
        const getTokenFn = (key) => __awaiter(this, void 0, void 0, function* () {
            const token = yield preferences_1.Preferences.get({ key });
            return token === null || token === void 0 ? void 0 : token.value;
        });
        const setTokenFn = (key, value) => __awaiter(this, void 0, void 0, function* () {
            yield preferences_1.Preferences.set({
                key: key,
                value: value,
            });
        });
        const removeTokenFn = (key) => __awaiter(this, void 0, void 0, function* () {
            yield preferences_1.Preferences.remove({ key: key });
        });
        // set the preferences storage methods only for native platforms
        // and run this effect only once during component mount
        if (core_1.Capacitor.isNativePlatform()) {
            (0, token_1.setAuthTokenStorageMethods)(getTokenFn, setTokenFn, removeTokenFn);
        }
    }, []);
    return (react_1.default.createElement(exports.CapacitorContext.Provider, { value: capacitor }, children));
}
const useCapacitor = () => {
    const capacitor = (0, react_1.useContext)(exports.CapacitorContext);
    if (!capacitor) {
        throw new Error('useCapacitor must be used within a <CapacitorProvider>');
    }
    return capacitor;
};
exports.useCapacitor = useCapacitor;
//# sourceMappingURL=useCapacitor.js.map